var finansudd = finansudd || {};

finansudd.frontpageHero = new function() {

    this.init = function () {

        if ($('.hero-title a').length) {
            $('a').addClass('hero-link-tag');
        }
    };
}